import { render, staticRenderFns } from "./client-change-level.vue?vue&type=template&id=47f222ec&"
import script from "./client-change-level.vue?vue&type=script&lang=js&"
export * from "./client-change-level.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports